export const CHARGE_RULE_LABELS: Record<string, string> = {
  pitch_category_night: "Stellplatz-Nacht (nach Kategorie)",
  adult_night: "Erwachsene pro Nacht",
  child_night: "Kinder pro Nacht",
  dog_night: "Hunde pro Nacht",
  electricity_night: "Strom pro Nacht",
  electricity_kwh: "Strom pro kWh",
  visitor_adult: "Besucher Erwachsene",
  visitor_child: "Besucher Kinder",
  visitor_extra_car: "Zusätzliche Autos",
};

export function chargeRuleLabel(ruleType: string): string {
  return CHARGE_RULE_LABELS[ruleType] ?? ruleType;
}
